import React, { createContext, useState } from 'react';

import ImxImrSeasonData from './ImxImrSeasonData';

export const ImxImrSeasonStateContext = createContext();

const ImxImrSeasonContextProvider = ({ children }) => {
  const stateHook = useState(ImxImrSeasonData.INITIAL_STATE);

  return (
    <ImxImrSeasonStateContext.Provider value={stateHook}>
      {children}
    </ImxImrSeasonStateContext.Provider>
  );
};

export default ImxImrSeasonContextProvider;